import { Link } from 'react-router-dom';
import '../styles/platform.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';

function Uxbooster() {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <section id="uxbooster-banner" className="ux-banner">
        <div
          className="m-auto banner-container"
          data-aos="fade-right"
          data-aos-duration="700"
          data-aos-once="true"
        >
          <div className="mb-32">
            <img src="./images/logo-uxbooster.svg" alt="uxboosterlogoimage" />
          </div>
          <p
            className="fs-md fw-bold mb-24"
            data-aos="fade-right"
            data-aos-duration="700"
            data-aos-once="true"
            data-aos-delay="100"
          >
            기업의 다양한 업무 시스템을 효율적으로
            <br className="pc-none" /> 구축할 수 있도록
            <br className="mo-none" />
            지원하는 웹 기반의 프레임워크
          </p>
          <p
            className="fs-base mb-60"
            data-aos="fade-right"
            data-aos-duration="700"
            data-aos-once="true"
            data-aos-delay="200"
          >
            UXBooster는 반응형 웹을 지원하여 다양한 디바이스에서 최적화된 화면을 제공합니다.&nbsp;
            <br className="mo-none" />
            이를 통해 웹사이트의 접근성과 사용자 만족도를 향상시킬 수 있습니다.
          </p>
          <ul
            className="ux-button"
            data-aos="fade-right"
            data-aos-duration="700"
            data-aos-once="true"
            data-aos-delay="300"
          >
            <li>
              <Link to="/contact?service=uxbooster&no=02" className="btn-outline fw-bold">
                소개자료 문의
              </Link>
            </li>
            <li>
              <Link to="/contact?service=uxbooster&no=01" className="btn-filled fw-bold">
                서비스 도입 문의
              </Link>
            </li>
          </ul>
        </div>
      </section>
      <section id="uxbooster-intro">
        <div className="m-auto content-padding">
          <h3 className="ux-content-title">
            <strong>UXBooster</strong> 를 사용해야 하는 이유
          </h3>
          <div className="reason-container content-gap">
            <div className="reason-content">
              <div className="reason">
                <img src="./images/ico-uxb-reason.svg" alt="" />
                <span className="fs-base">기업 환경에 최적화된 시스템 구축</span>
              </div>
              <div className="reason">
                <img src="./images/ico-uxb-reason.svg" alt="" />
                <span className="fs-base">최신 웹 트렌드 및 고객 요구에 유연하게 대응</span>
              </div>
            </div>
            <div className="reason-content">
              <div className="reason">
                <img src="./images/ico-uxb-reason.svg" alt="" />
                <span className="fs-base">개발 생산성과 유지보수 효율성 향상</span>
              </div>
              <div className="reason">
                <img src="./images/ico-uxb-reason.svg" alt="" />
                <span className="fs-base">다수의 프로젝트 수행을 통한 검증된 품질</span>
              </div>
            </div>
            <div className="reason-content">
              <div className="reason">
                <img src="./images/ico-uxb-reason.svg" alt="" />
                <span className="fs-base">
                  웹 표준 기반 공통 코드 및 템플릿 제공으로 개발 기간 단축
                </span>
              </div>
            </div>
          </div>
          <h3 className="ux-content-title">
            <strong>UXBooster</strong> 만의 특장점
          </h3>
          <div className="content-bg uxbooster-strength-container">
            <div className="content-box uxbooster-strength-box ux-boxbar-y">
              <div className="uxbooster-strength-title">
                <img
                  src="./images/ico-uxbooster-strength01.svg"
                  alt="strength-icon01"
                  className="mb-16"
                />
                <p className="color-uxb fs-md fw-bold">
                  시스템 개발을 위한&nbsp;
                  <br className="mo-none" />
                  UXBooster 구성
                </p>
              </div>
              <ul className="uxbooster-strength-content">
                <li className="text-dot fs-base">웹 · 모바일에 특화된 Frame 세팅</li>
                <li className="text-dot fs-base">Spring 기반의 TAKE Framework 제공</li>
                <li>
                  <p className="text-dot fs-base">개발 공통화를 위한 표준화 JS코드 제공</p>
                  <p className="text-bar ml-12 mt-4">
                    Transaction 처리 / Message 처리 / File Upload · Download 처리 / 다양한 Util 제공
                    등
                  </p>
                </li>
                <li className="text-dot fs-base">
                  다양한 유형의 업무 화면에 최적화된 템플릿 및 컨포넌트 샘플 제공
                </li>
              </ul>
            </div>
            <div className="content-box uxbooster-strength-box ux-boxbar-y">
              <div className="uxbooster-strength-title">
                <img
                  src="./images/ico-uxbooster-strength02.svg"
                  alt="strength-icon02"
                  className="mb-12"
                />
                <p className="color-uxb fs-md fw-bold">
                  사용자 편의를 위한&nbsp;
                  <br className="mo-none" />
                  주요기능 구성
                </p>
              </div>
              <ul className="uxbooster-strength-content">
                <li>
                  <p className="text-dot fs-base">관리자 기능</p>
                  <ul className="ml-12 mt-4">
                    <li className="text-bar">시스템 관리</li>
                    <li className="text-bar">프로젝트 관리</li>
                    <li className="text-bar">공지사항 관리</li>
                    <li className="text-bar">프로그램 관리</li>
                    <li className="text-bar">사용자 관리</li>
                    <li className="text-bar">통계 관리</li>
                  </ul>
                </li>
                <li>
                  <p className="text-dot fs-base">커스텀 기능</p>
                  <ul className="ml-12 mt-4">
                    <li className="text-bar">공지사항</li>
                    <li className="text-bar">게시판</li>
                    <li className="text-bar">타임라인</li>
                    <li className="text-bar">일정관리</li>
                    <li className="text-bar">주소록</li>
                    <li className="text-bar">문서함</li>
                  </ul>
                </li>
                <li>
                  <p className="text-dot fs-base">그리드 기능</p>
                  <p className="text-bar ml-12 mt-4">기업 업무에 최적화된 그리드 공통 기능</p>
                  <p className="text-bar ml-12">
                    Check, 정렬, 찾기, 바꾸기, 틀 고정, Excel Import/Export, Filter 등
                  </p>
                </li>
              </ul>
            </div>
            <div className="content-box uxbooster-strength-box ux-boxbar-y">
              <div className="uxbooster-strength-title">
                <img
                  src="./images/ico-uxbooster-strength03.svg"
                  alt="strength-icon03"
                  className="mb-12"
                />
                <p className="color-uxb fs-md fw-bold">가이드 지원</p>
              </div>
              <ul className="uxbooster-strength-content">
                <li>
                  <p className="text-dot fs-base">전담 컨설턴트 배정</p>
                  <p className="text-bar color-caption ml-12 mt-4">비상주 가이드 지원</p>
                </li>
                <li className="text-dot fs-base">UI 표준 개발 가이드 문서 제공</li>
                <li className="text-dot fs-base">
                  서버 프레임워크 구성 및 비즈니스 로직 개발 가이드 지원
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section id="uxbooster-architecture">
        <div className="m-auto content-padding">
          <h3 className="ux-content-title">
            <strong>UXBooster</strong> 시스템 아키텍쳐
          </h3>
          <div className="img-uxbooster-architecture">
            <img src="./images/img-uxbooster-architecture.svg" alt="uxbooster-architecture" />
          </div>
          <div className="img-uxbooster-architecture-mo">
            <img src="./images/img-uxbooster-architecture-mo.svg" alt="uxbooster-architecture" />
          </div>
        </div>
      </section>
      <section id="uxbooster-effect">
        <div className="m-auto content-padding">
          <h3 className="ux-content-title">
            <strong>UXBooster</strong> 도입 기대효과
          </h3>
          <div className="uxbooster-effect-container">
            <div className="content-box uxbooster-effect-box box01">
              <p className="fs-base fw-bold">일반적인 시스템 개발</p>
              <ul>
                <li className="fs-base">UI 공통 개발자 4~5M/M</li>
                <li className="fs-base">서버 개발자 2M/M</li>
                <li className="fs-base">디자이너/퍼블리셔 2M/M</li>
              </ul>
            </div>
            <div className="arrow">
              <img src="./images/ux-arrow.svg" alt="nextarrow" />
            </div>
            <div className="content-box uxbooster-effect-box box02 ux-boxbar-x">
              <img src="./images/logo-uxbooster-sm.svg" alt="uxbooster-logo" />
              <div className="uxbooster-effect-use">
                <ul>
                  <li className="fs-base fw-bold">UXBooster 컨설턴트 1M/M</li>
                  <li className="fs-base fw-bold">디자이너/퍼블리셔 1M/M</li>
                </ul>
                <div className="miniarrow">
                  <img src="./images/ux-minarrow.svg" alt="mini-nextarrow" />
                </div>
                <div className="uxbooster-effect-fin text-center fw-bold fs-base">
                  <p>
                    비용 30%
                    <br />
                    <strong>DOWN</strong>
                  </p>
                  <p>
                    기간 1~3M
                    <br />
                    <strong>DOWN</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="ux-contact">
        <div className="contact-container m-auto">
          <div
            className="contact-text"
            data-aos="fade-up"
            data-aos-duration="400"
            data-aos-once="true"
          >
            <p className="fs-xxl">지금 바로</p>
            <img src="./images/logo-uxbooster-white.svg" alt="uxbooster-logo" />
            <p className="fs-xxl">를 만나보세요!</p>
          </div>
          <div
            className="contact-button fs-base"
            data-aos="fade-up"
            data-aos-duration="400"
            data-aos-once="true"
            data-aos-delay="300"
          >
            <Link to="/contact?service=uxbooster&no=01" className="color-uxb">
              서비스 도입 문의
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default Uxbooster;
